var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topology-view"},[_c('div',{attrs:{"id":"service-topology"}}),_c('module-border',{staticStyle:{"bottom":"0"},attrs:{"title":"业务列表","width":"940px","height":"270px"}},[_c('topology-menu',{on:{"currentTopology":item => (_vm.currentTopologyId = item.id),"refresh":_vm.handleRefresh}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }